import * as React from "react";
import { useTranslation } from "react-i18next";
import { useContext, useState } from "react";
import WidgetEditApplyAllChangesContext from "views/components/contexts/WidgetEditApplyAllChangesContext";
import { ModalSubmit } from "components/common";
import DisableSubmissionStateContext from "views/components/contexts/DisableSubmissionStateContext";
const SaveOrCancelButtons = ({ onCancel }) => {
  const { t } = useTranslation("widgets");
  const { applyAllWidgetChanges } = useContext(WidgetEditApplyAllChangesContext);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { disabled: disabledSubmit } = useContext(DisableSubmissionStateContext);
  const _onSubmit = () => {
    setIsSubmitting(true);
    return applyAllWidgetChanges().then(() => {
      setIsSubmitting(false);
    }).catch(() => {
      setIsSubmitting(false);
    });
  };
  return /* @__PURE__ */ React.createElement(
    ModalSubmit,
    {
      isAsyncSubmit: true,
      submitButtonText: t("widget_edit.update"),
      submitLoadingText: t("widget_edit.updating"),
      onSubmit: _onSubmit,
      submitButtonType: "button",
      disabledSubmit,
      isSubmitting,
      displayCancel: true,
      onCancel
    }
  );
};
export default SaveOrCancelButtons;
